import React from "react";
import { Check, Minus } from "lucide-react";
import SiteShell from "../components/site/SiteShell";
import { Container, SectionHead, Button } from "../components/site/ui";
import { Reveal } from "../components/site/Reveal";
import PackageCards from "../components/site/PackageCards";
import { PACKAGES } from "../data/site";

const ROWS = [
  ["Custom design & mobile-first", true, true, true],
  ["Hosting, SSL & basic SEO", true, true, true],
  ["Sell, book & take payments", false, true, true],
  ["Advanced SEO & analytics", false, true, true],
  ["Customer accounts & dashboards", false, false, true],
  ["Custom apps & integrations", false, false, true],
];

export default function PricingPage() {
  return (
    <SiteShell title="Pricing — GoBuildWeb | Websites from $999" description="Simple, transparent pricing. Basic $999, Sales $1,499+, Network $3,000+. Compare packages and start your project with GoBuildWeb.">
      <section className="pt-[72px]">
        <Container className="py-16 text-center md:py-20">
          <Reveal>
            <SectionHead center eyebrow="Pricing" title="Simple, transparent pricing" sub="Start where you are. Grow when you're ready. No surprises." />
          </Reveal>
        </Container>
      </section>

      <section className="pb-8"><Container><PackageCards /></Container></section>

      {/* Comparison table */}
      <section className="py-16 md:py-24">
        <Container>
          <SectionHead center title="Compare packages" className="mb-10" />
          <Reveal>
            <div className="overflow-x-auto rounded-2xl border border-white/10">
              <table className="w-full min-w-[640px] border-collapse text-left" data-testid="pricing-compare">
                <thead>
                  <tr className="border-b border-white/10 bg-white/[0.03]">
                    <th className="p-5 text-sm font-semibold text-zinc-400">Features</th>
                    {PACKAGES.map((p) => (
                      <th key={p.id} className="p-5 text-center">
                        <div className="font-display text-lg font-bold text-white">{p.name}</div>
                        <div className="text-sm font-semibold text-gold-500">{p.price}</div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {ROWS.map((r, idx) => (
                    <tr key={idx} className="border-b border-white/5">
                      <td className="p-4 text-sm text-zinc-200">{r[0]}</td>
                      {[1, 2, 3].map((ci) => (
                        <td key={ci} className="p-4 text-center">
                          {r[ci] ? <Check size={18} className="mx-auto text-gold-500" /> : <Minus size={16} className="mx-auto text-zinc-700" />}
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr>
                    <td className="p-4" />
                    {PACKAGES.map((p) => (
                      <td key={p.id} className="p-4 text-center">
                        <Button to={`/get-started?package=${p.id}`} size="md" icon={false} variant={p.popular ? "primary" : "secondary"} data-testid={`pricing-cta-${p.id}`}>Choose</Button>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-12 rounded-3xl border border-gold-500/30 bg-gradient-to-br from-gold-500/[0.10] to-transparent p-10 text-center">
              <h3 className="font-display text-2xl font-bold text-white md:text-3xl">Need something custom?</h3>
              <p className="mt-2 text-zinc-300">Let's build it. Tell us what you have in mind and we'll scope it with you.</p>
              <div className="mt-7 flex justify-center"><Button to="/get-started" size="lg" data-testid="pricing-contact">Contact GoBuildWeb</Button></div>
            </div>
          </Reveal>
        </Container>
      </section>
    </SiteShell>
  );
}
